<script>
import { mapActions, mapGetters } from "vuex";
import { countriesCollection } from "@/firebaseConfig";
import Raven from "raven-js";

export default {
  name: "CountriesMixin",
  data() {
    return {};
  },
  methods: {
    ...mapActions(["setCountries", "setIsCountriesLoading"]),
    requestCountries() {
      const yearId = this.$route.params.year;
      if (yearId != null) {
        this.setIsCountriesLoading(true);
        countriesCollection
          .where("year", "==", yearId)
          .orderBy("name", "asc")
          .get()
          .then(querySnapshot => {
            this.setCountries(
              querySnapshot.docs.map(doc => {
                return { id: doc.id, ...doc.data() };
              })
            );
          })
          .catch(err => {
            Raven.captureException(err);
            this.setCountries([]);
            this.$notify({
              group: "app",
              text: `Hiba az országok betöltése közben!`,
              type: "error"
            });
          })
          .finally(() => {
            this.setIsCountriesLoading(false);
          });
      }
    }
  }
};
</script>